<template>
  <div class="fixed inset-0 z-[70] bg-black/40 flex items-center justify-center p-4">
    <div class="bg-surface rounded-xl shadow-2xl w-full max-w-sm p-6 space-y-4" @click.stop>
      <div class="flex justify-between items-center">
        <h3 class="text-lg font-semibold text-gray-800">Adicionar Cupom</h3>
        <button @click="$emit('close')" class="text-gray-400 hover:text-gray-600 text-2xl">&times;</button>
      </div>
      
      <div class="space-y-2">
        <input
          v-model="code"
          type="text"
          class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 uppercase"
          placeholder="Código do cupom"
          :disabled="loading"
          @keyup.enter="apply"
        />
        <p v-if="localError" class="text-sm text-red-600">{{ localError }}</p>
      </div>

      <button
        @click="apply"
        :disabled="loading || !code.trim()"
        class="w-full bg-blue-600 text-white py-3 rounded-lg font-medium hover:bg-blue-700 disabled:bg-gray-300 transition-colors"
      >
        {{ loading ? 'Validando...' : 'Aplicar Desconto' }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useSubscriptionStore } from "@/stores/useSubscriptionStore";

const props = defineProps({
  planId: { type: Number, required: true }
});

const emit = defineEmits(['close', 'applied']);
const subscriptionStore = useSubscriptionStore();

const code = ref("");
const loading = ref(false);
const localError = ref("");

async function apply() {
  if (!code.value.trim()) return;
  localError.value = "";
  loading.value = true;
  
  try {
    // Volta a enviar apenas código e planId
    const result = await subscriptionStore.validateCoupon(code.value.trim(), props.planId);
    
    emit('applied', result);
    emit('close');
  } catch (err) {
    localError.value = err.message || "Cupom inválido ou expirado.";
  } finally {
    loading.value = false;
  }
}
</script>